import type { ReactNode } from "react";
import {
	MAIN_CONTENT_ID,
	PublicFooter,
	PublicHeader,
} from "@/components/public-layout";

export function MarketingPageShell({ children }: { children: ReactNode }) {
	return (
		<div className="flex min-h-svh flex-col bg-background text-foreground">
			<PublicHeader />
			<main id={MAIN_CONTENT_ID} className="flex-1">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<div className="flex flex-col gap-px bg-border">
						<div
							aria-hidden="true"
							className="h-14 rounded-md bg-background sm:h-16"
						/>
						{children}
					</div>
				</div>
			</main>
			<PublicFooter />
		</div>
	);
}
